export interface Invoice {
	id: number;
	issueDate: string | null;
	amount: string;
	amountWithVat: string;
	contractor: Contractor;
	currency: string;
	note: string;
	number: string;
	ourCompany: Contractor;
	paymentDeadline: string;
	paymentTime: string;
	status: string;
	vat: string;
	vindicated: boolean;
	shouldVindicate: boolean;
	navigatorId: number;
	mailsSentAutomatically: number;
	mailsSentManually: number;
	carrierReference: string;
	daysAfterDeadline: number;
	deferredPaymentDays: number;
	declaredPaymentDate?: string;
	internalStatus?: InternalStatusDto | null;
}

export type TableInvoice = Invoice & {
	noteLoader: boolean;
	declaredPaymentDateLoader: boolean;
	internalStatusLoader: boolean;
};

export type InvoicePatchPayload = Omit<Partial<Invoice>, 'internalStatus'> & {
	internalStatus?: number | null;
};

export interface Contractor {
	id: number;
	navigatorId: number;
	fullName: string;
	prefix: string;
	shortName: string;
	address: string;
	nip: string;
	mails: string[] | null;
	phone: string;
	zipCode: string;
	street: string;
	city: string;
	isOskar: boolean;
	note?: string;
	internalStatus?: InternalStatusDto | null;
}

export type TableContractor = Contractor & {
	mailLoader: boolean;
	phoneLoader: boolean;
	noteLoader: boolean;
	internalStatusLoader: boolean;
};

export type ContractorPatchPayload = Omit<Partial<Contractor>, 'internalStatus'> & {
	internalStatus?: number | null;
};

export interface MailPreviewResponse {
	company: string;
	files: string[];
	mails: string[];
	message: string;
	nip: string;
	subject: string;
	templateId: number;
	invoice: number;
}

export interface MailBulkSendPayload {
	mails: string[];
	subject: string;
	message: string;
	invoice: number;
	template: number;
	cc?: string[];
	attachments?: File[];
}

export const STATUS_VINDICATION_CODES = ['C', 'N', 'T'] as const;
export type StatusVindicationCode = (typeof STATUS_VINDICATION_CODES)[number];

export const STATUS_VINDICATION_LABELS = {
	C: 'Spłata częściowa',
	N: 'Brak spłaty',
	T: 'Spłacony',
} as const satisfies Record<StatusVindicationCode, string>;

export const STATUS_VINDICATION_FILTERS = STATUS_VINDICATION_CODES.map((code) => ({
	value: code,
	label: STATUS_VINDICATION_LABELS[code],
})) satisfies ReadonlyArray<{ value: StatusVindicationCode; label: string }>;

export interface InternalStatusDto {
	id: number;
	name: string;
	description: string;
}

export type InvoiceUserEmailMap = Record<string, number>;

export interface IssuedByOption {
	id: number;
	email: string;
}

export interface ProfileDto {
	id: number;
	firstName: string;
	lastName: string;
	email: string;
}

export interface MailTemplateDto {
	id: number;
	name: string;
	content: string;
	subject: string;
}

export interface BaseContractorMailTemplate<TMailTemplate> {
	id?: number;
	contractor: number;
	mailTemplate: TMailTemplate;
	daysToSend: number;
}

export type ContractorMailTemplatePayload = BaseContractorMailTemplate<number>;

export type ContractorMailTemplateResponse = BaseContractorMailTemplate<MailTemplateDto>;
